import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { useViewport } from "@tecreation/funnel-components"
import { useLocation } from "react-router"
import "./AnimatedOrderRoute.css"

export default function AnimatedOrderRoute({ children, style, className, route }) {
	const { sm, md } = useViewport()

	const { action, animation } = useCustomNavigation()
	//We apply a empty animation with random values to secure that a page without transition get removed on the next transition effect
	//If we jump to a page A without a transition then page A dont get removed if we jump with a transition to next page B
	const appliedAnimation =
		(sm || md) && animation && Animations[animation]
			? Animations[animation][action === "PUSH" || action === "REPLACE" ? "forwards" : "backwards"]
			: Animations.empty

	//we apply a m.div also we don't have a animation to handle exit animations from screen that did come in without a animation. Otherwise the screen would not have a exit animation
	//while the new screen enters with a animation
	// const MOTION = sm || md ? m.div : "div";

	const MOTION = "div"

	return (
		<MOTION
			className={"animatedOrderRoute scrollable color-bg-default" + useLocation().pathname + " " + className}
			{...appliedAnimation}
			style={style}
			key={route}
		>
			{children}
		</MOTION>
	)
}

const Animations = {
	//only to fix the issue that the animations goes wrong if we had a transition without an animation before
	empty: {
		initial: {
			transform: "translateX(100%)",
			zIndex: 1,
		},
		animate: {
			transform: "translateX(0)",
			transitionEnd: { position: "unset" },
		},
		transition: {
			type: "tween",
			stiffness: 100,
			duration: 0,
			ease: "easeInOut",
		},
	},
	fullSlide: {
		forwards: {
			initial: {
				transform: "translateX(100%)",
			},
			animate: {
				transform: "translateX(0%)",
			},

			transition: {
				type: "tween",
				stiffness: 100,
				duration: 0.2,
				ease: "easeOut",
			},
		},
		backwards: {
			initial: {
				transform: "translate3d(-100%,0,0)",
				zIndex: 2,
			},
			animate: {
				transform: "translate3d(0,0,0)",
				zIndex: 2,
			},
			transition: {
				type: "tween",
				stiffness: 100,
				duration: 0.2,
				ease: "easeOut",
			},
		},
	},
}

const OrderAnimationTypes = {
	fullSlide: "fullSlide",
}

export { OrderAnimationTypes }
